import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Logo } from "@/components/common";

function Shell({ title, subtitle, children }) {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md animate-rise">
        <div className="flex justify-center mb-6"><Logo size="text-3xl" /></div>
        <div className="card-surface rounded-2xl p-7 gold-glow">
          <h1 className="font-display text-2xl font-bold text-white text-center">{title}</h1>
          <p className="text-slate-400 text-sm text-center mt-1 mb-6">{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
}

const inputCls = "w-full bg-vault border border-gold/20 rounded-xl px-4 py-3 text-white placeholder-slate-500 focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold transition-colors";
const btnCls = "w-full gold-gradient text-obsidian font-bold py-3 rounded-xl hover:brightness-110 transition-[filter] disabled:opacity-60";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/drops");
    } catch (err) {
      toast.error(apiError(err));
    } finally { setLoading(false); }
  };

  return (
    <Shell title="Welcome back" subtitle="Log in to grab seats and enter drops">
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required className={inputCls} />
        <input data-testid="login-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required className={inputCls} />
        <button data-testid="login-submit" disabled={loading} className={btnCls}>{loading ? "Logging in…" : "Log in"}</button>
      </form>
      <div className="mt-4 flex items-center justify-between text-sm">
        <Link to="/forgot-password" className="text-slate-400 hover:text-gold" data-testid="forgot-link">Forgot password?</Link>
        <Link to="/signup" className="text-gold font-semibold" data-testid="to-signup">Create account</Link>
      </div>
    </Shell>
  );
}

export { Shell, inputCls, btnCls };
